import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const X: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M18 6 6 18' }],
    ['path', { d: 'm6 6 12 12' }],
  ],
];

export default X;
